export default __webpack_public_path__ + "static/media/18-min.bad98f0e.jpg";